import type { GlobalState } from '../global/types';
import { LeftColumnContent } from '../types';

/** Jeda ingest/monitor saat Settings terbuka atau tab tidak aktif — hindari freeze UI. */
export function shouldPauseRasiBackgroundWork(global: GlobalState): boolean {
  if (typeof document !== 'undefined' && document.hidden) {
    return true;
  }
  return Object.values(global.byTabId).some(
    (tab) => tab.leftColumn.contentKey === LeftColumnContent.Settings,
  );
}

export function deferRasiHeavyWork(work: () => void): void {
  if (typeof requestIdleCallback !== 'undefined') {
    requestIdleCallback(() => work(), { timeout: 8000 });
    return;
  }
  window.setTimeout(work, 250);
}
